import request from '@/utils/request'

// 生成学生学情分析
export function generateStudentAnalysis(studentId) {
  return request({
    url: `/student-analysis/generate/${studentId}`,
    method: 'post'
  })
}

// 获取学生最新学情分析
export function getLatestStudentAnalysis(studentId) {
  return request({
    url: `/student-analysis/latest/${studentId}`,
    method: 'get'
  })
}

// 生成当前用户学情分析
export function generateMyAnalysis() {
  return request({
    url: '/student-analysis/generate/my',
    method: 'post'
  })
}

// 获取当前用户最新学情分析
export function getMyLatestAnalysis() {
  return request({
    url: '/student-analysis/latest/my',
    method: 'get'
  })
}
